import { render, staticRenderFns } from "./QuestionPart.vue?vue&type=template&id=5fd1f145&scoped=true&"
import script from "./QuestionPart.vue?vue&type=script&lang=js&"
export * from "./QuestionPart.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPart.vue?vue&type=style&index=0&id=5fd1f145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1f145",
  null
  
)

export default component.exports